import React from 'react'
import { object } from 'prop-types'
import { Link } from 'react-router-dom'
import styles from './Footer.styl'
import { withContext } from '../../../utils/withContext'

const footerData = '2015 - 2017. Armada Portuguesa do Trail .<br/> Direitos reservados . Paulo Pires'
const localeData = [
	{
		locale: '',
		name: 'Pt'
	},
	{
		locale: 'en',
		name: 'En'
	}
]
class Footer extends React.Component {
	static propTypes = {
		context: object
	}

	renderLocales(changeLocale) {
		return localeData.map((ele, i) => {
			const localeLink = changeLocale(ele.locale)
			const Tag = localeLink ? Link : 'div'
			return (
				<small key={ i }>{ <Tag to={ changeLocale(ele.locale) }>{ ele.name }</Tag> }</small>
			)
		})
	}
	render() {
		const { context: { changeLocale } } = this.props
		return (
			<div className={ styles['footer'] }>
				<div className={ styles['content'] }>
					<p dangerouslySetInnerHTML={ { __html: footerData } } />
					<img src="https://s3-eu-west-1.amazonaws.com/files.apt.pt/assets/metodos_pagamento.png" />
					<div className={ styles['locales'] }>
						{ this.renderLocales(changeLocale) }
					</div>
				</div>
			</div>
		)
	}
}

export default withContext(Footer)



// WEBPACK FOOTER //
// ./src/client/webapp/components/Footer/Footer.js